import React, { Suspense, useEffect } from 'react';

import { ApolloProvider } from '../components/ApolloProvider/ApolloProvider';
import { DocumentTitle } from '../components/documentTitle/DocumentTitle';
import { Localization } from '../components/localization/Localization';
import { setupGTM } from '../hooks/useSetupGTM';
import { Routes } from '../navigation/Routes';
import { PartnerConfigProvider } from './PartnerConfigProvider';

export const App: React.FC = () => {
  useEffect(() => {
    setupGTM();
  }, []);

  return (
    <Suspense fallback={null}>
      <ApolloProvider>
        <Localization>
          <PartnerConfigProvider>
            <DocumentTitle />
            <Routes />
          </PartnerConfigProvider>
        </Localization>
      </ApolloProvider>
    </Suspense>
  );
};
